var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartPackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.005,
    height: 15.005,
    viewBox: "0 0 15.005 15.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.5,116.958v9.184l6.752-2.655V114.3Z",
    transform: "translate(-272.247 -111.137)",
    fill: "#c7c0c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,123.487l6.752,2.655v-9.184L11,114.3Z",
    transform: "translate(-11 -111.137)",
    fill: "#c7c0c0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.839,11,58.8,13.091l6.039,2.376,6.039-2.376Z",
    transform: "translate(-57.336 -11)",
    fill: "#c7c0c0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartPackIcon);
export default __webpack_public_path__ + "static/media/chart-pack-icon.497ef47a.svg";
export { ForwardRef as ReactComponent };